import { Grid, Paper, TableContainer } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { usePermissions } from "react-admin";
import { useNotifyError } from "utils/notifiers/useNotifyError";

import { httpClient } from "../../api/httpClient";
import { DataExportTable } from "../../components/dialogs/ExportDialog/DataExportTable";
import {
	ExportServerCSVButton,
	ExportServerXLSXButton,
} from "../../components/dialogs/ExportDialog/ExportServerButton";
import { OrdersExportView } from "../../components/dialogs/OrdersExportDialog";
import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";
import { useTerminalFieldVisibility } from "hooks/useTerminalFieldVisibility";

export const useStyles = makeStyles((theme) => ({
	tableGrid: {
		width: "1px",
		overflow: "hidden",
		marginTop: "30px",
	},
	tableContainer: {
		height: "calc(100vh - 250px)",
	},
}));

export const ExportPage = ({ filters, titleButtons, endpoint, setExportDate, sort, tableRef }) => {
	const classes = useStyles();

	return (
		<React.Fragment>
			<Grid container spacing={2} alignContent="center" alignItems="center">
				<Grid container item xs={12} alignContent="space-between" spacing={2}>
					{React.Children.map(titleButtons, (button, index) => (
						<Grid item key={index}>
							{button}
						</Grid>
					))}
					<Grid item>
						<ExportServerCSVButton endpoint={endpoint} filters={filters} sort={sort} />
					</Grid>
					<Grid item>
						<ExportServerXLSXButton endpoint={endpoint} filters={filters} sort={sort} />
					</Grid>
				</Grid>
				<Grid
					item
					xs={12}
					spacing={2}
					alignContent="center"
					alignItems="center"
					className={classes.tableGrid}
				>
					<TableContainer
						component={Paper}
						variant="outlined"
						elevation={0}
						className={classes.tableContainer}
					>
						<DataExportTable
							endpoint={endpoint}
							ref={tableRef}
							filters={filters}
							sort={sort}
							setExportDate={setExportDate}
						/>
					</TableContainer>
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

const AdminOrdersExportSearch = () => {
	const notifyError = useNotifyError();
	const { permissions } = usePermissions();
	const [columns, setColumns] = useState([]);
	const [columnsChoices, setColumnsChoices] = useState([]);
	const [headerFilter, setHeaderFilter] = useState({});
	const { data: globalFilter = {} } = useGridUserDataGlobalFiltersContext();
	const terminalId = globalFilter?.terminal_id?.[0];
	const { hiddenFields = [], currentTerminal } = useTerminalFieldVisibility(terminalId);

	const initDateFrom = new Date(Date.now());
	const isTerminalDataReady = !terminalId || currentTerminal !== undefined;

	console.log("hiddenFields", hiddenFields);
	useEffect(() => {
		if (!isTerminalDataReady) {
			return;
		}

		const filters = {
			...headerFilter,
		};
		const queryString = `filter=${encodeURIComponent(JSON.stringify(filters))}`;
		httpClient(`orders-export-header?${queryString}`)
			.then(({ json }) => {
				if (json) {
					const _filterColumns = json.filter((x) => !hiddenFields.includes(x[0]));
					const _columnsChoices = _filterColumns.map((x) => ({ id: x[0], name: x[1] }));
					const _columnsSelected = _filterColumns.map((x) => x[0]);
					setColumnsChoices(_columnsChoices);
					setColumns(_columnsSelected);
				}
			})
			.catch((error) => {
				notifyError(error);
			})
			.finally(() => {});
	}, [headerFilter, hiddenFields, isTerminalDataReady]);

	return (
		<OrdersExportView
			userId={permissions?.id}
			initDateFrom={initDateFrom}
			columns={columns}
			columnsChoices={columnsChoices}
			ViewComponent={ExportPage}
			setHeaderFilter={setHeaderFilter}
			hiddenFields={hiddenFields}
		/>
	);
};
export default AdminOrdersExportSearch;
